// src/components/workspace/SolvedConfirmationBanner.js
import React from "react";
import { motion, AnimatePresence } from "framer-motion";

/**
 * Banner component that shows when one party has clicked "Solved" 
 * but the other party hasn't confirmed yet
 */
function SolvedConfirmationBanner({ problem, currentUser }) {
  if (!problem || !currentUser) return null;

  const isClient = problem.clientId === currentUser.uid;
  const isHelper = problem.helperId === currentUser.uid;

  // Check if expert has confirmed but client hasn't
  const expertSolved = Boolean(problem.expertSolved || problem.helperMarkedDone);
  const clientSolved = Boolean(problem.clientSolved || problem.clientMarkedDone);

  // Show banner to client if expert has solved but client hasn't
  const showToClient = isClient && expertSolved && !clientSolved && problem.status !== "completed";
  
  // Show banner to expert if client has solved but expert hasn't
  const showToExpert = isHelper && clientSolved && !expertSolved && problem.status !== "completed";

  if (!showToClient && !showToExpert) return null;

  const message = showToClient
    ? "The specialist marked this problem as solved. Please confirm if the issue is resolved."
    : "The requester confirmed this issue as solved. Please confirm to complete the task.";

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="w-full"
      >
        <div className="bg-blue-50 border border-blue-500/60 rounded-xl px-3 py-3 sm:px-4 sm:py-3 shadow-sm">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0">
              <svg
                className="w-6 h-6 text-blue-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-blue-900">{message}</p>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

export default SolvedConfirmationBanner;

